import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import { useForm } from 'react-hook-form';
import validator from 'validator';
import DatePicker from 'react-datepicker';
import SelectPlan from './SelectPlan';
import { AJAX_URL, SITE_URL } from '../../config';

export default function EventForm({
  setFormType,
  formType,
  paidPlan,
  setPaidPlan,
  setCoupon,
  setPaidFormValid,
  paidFormIsValid,
  setFormData
}) {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [errors, setErrors] = useState([]);
  const { register, handleSubmit } = useForm();
  const couponInput = useRef(null);
  const maxTitleLength = 60;

  const handleStartDate = (date) => {
    setStartDate(date);
  };

  const handleEndDate = (date) => {
    setEndDate(date);
  };

  const changeFormType = (type) => {
    setFormType(type);
  };

  const maskPhoneInput = (e) => {
    var x = e.target.value
      .replace(/\D/g, '')
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return (e.target.value = !x[2]
      ? x[1]
      : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
  };

  $(document).ready(function () {
    $('#website').change(function () {
      if (!/^http[s]?:\/\//.test(this.value)) {
        this.value = 'https://' + this.value;
      }
    });
  });

  const onSubmit = async (data) => {
    data.startDate =
      startDate !== null && startDate !== '' && startDate !== undefined
        ? startDate.toLocaleDateString('en-CA')
        : '';

    data.endDate =
      endDate !== null && endDate !== '' && endDate !== undefined
        ? endDate.toLocaleDateString('en-CA')
        : '';

    data.image =
      data.image !== undefined && data.image.length > 0 ? data.image : '';
    data.file =
      data.file !== undefined && data.file.length > 0 ? data.file : '';

    if (!handleValidation(data)) return;

    const formData = {
      name: data.event_title,
      description: data.eventDescription,
      region: data.region,
      type: data.type,
      addressOne: data.addressOne,
      addressTwo: data.addressTwo,
      city: data.city,
      state: data.state,
      zip: data.zip,
      phone: data.phone,
      website: data.website,
      image: data.image,
      file: data.file,
      startDate: data.startDate,
      endDate: data.endDate,
      paidForm: formType === 'paid' ? true : false
    };

    if (formType === 'paid') {
      setFormData(formData);
      setPaidFormValid(true);
    } else if (formType === 'free') {
      await $.ajax({
        type: 'POST',
        url: `${AJAX_URL}post_wlSubmitEvent`,
        dataType: 'json',
        encode: true,
        data: formData,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
      }).then((r) => {
        window.location.href = `${SITE_URL}/events/submit-event/thank-you?post_id=${r.data}`;
      });
    }
  };

  const handleTitleChange = (event) => {
    $('#title-limit').html(maxTitleLength - event.target.value.length);
  };

  const handleValidation = (data) => {
    let errorsList = [];

    if (validator.isEmpty(data.event_title)) errorsList.push('event_title');
    if (validator.isEmpty(data.region)) errorsList.push('region');
    if (validator.isEmpty(data.type)) errorsList.push('type');
    if (validator.isEmpty(data.city)) errorsList.push('city');
    if (!validator.isDate(data.startDate)) errorsList.push('startDate');

    if (!validator.isEmpty(data.phone)) {
      !validator.isMobilePhone(data.phone) ? errorsList.push('phone') : '';
    }

    if (formType === 'paid') {
      if (validator.isEmpty(data.eventDescription))
        errorsList.push('eventDescription');
    }

    if (errorsList.length > 0) {
      setErrors(errorsList);
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    errors.forEach((err, index) => {
      const field = document.getElementsByName(`${err}`)[0];
      field.classList.add('validation-error');
      if (index === 0) {
        document
          .getElementsByClassName('add-event__choices')[0]
          .scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start'
          });
      }
    });
  }, [errors]);

  return (
    <div>
      <section className="section u--padding-bottom-0">
        <div className="container container--xl">
          <div className="grid grid--std grid--sm-screen">
            <div className="grid__col-lg-8">
              <div className="section__header u--display-flex u--justify-space-between relative">
                <h4 className="section__header-text">Add Your Event</h4>
                <span className="">
                  <span className="u--color-blue-light">*</span> Required Fields
                </span>
              </div>
              <FormTypeOptions
                changeFormType={changeFormType}
                formType={formType}
              />
              <form
                className="add-event__form"
                id="submit-event-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="grid grid--std">
                  <div className="grid__col-xs-12">
                    <div className="form__field">
                      <label className="form__label">
                        Event Name{' '}
                        <span className="u--color-blue-light">*</span>
                      </label>
                      <input
                        className="form__input"
                        type="text"
                        maxLength={maxTitleLength}
                        {...register('event_title')}
                        onChange={(e) => {
                          e.target.classList.remove('validation-error');
                          handleTitleChange(e);
                        }}
                        // onBlur={(e) =>
                        //   e.target.classList.remove('validation-error')
                        // }
                      />
                      <small className="form__help">
                        <span id="title-limit">{maxTitleLength}</span>{' '}
                        characters left in your event’s name
                      </small>
                    </div>
                  </div>
                </div>
                <div className="grid grid--std">
                  <div className="grid__col-xs-12">
                    <div className="form__field">
                      <label className="form__label">
                        Event Description{' '}
                        {formType === 'paid' && (
                          <span className="u--color-blue-light">*</span>
                        )}
                      </label>
                      <textarea
                        className="form__input"
                        id="add-event-description"
                        placeholder={
                          formType === 'free'
                            ? `Upgrade to a Featured Event to add a description`
                            : ''
                        }
                        {...register('eventDescription')}
                        onBlur={(e) =>
                          e.target.classList.remove('validation-error')
                        }
                        readOnly={formType === 'free' ? true : false}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="grid grid--std">
                  <div className="grid__col-xs-12">
                    <div className="form__field">
                      <label className="form__label">
                        Region <span className="u--color-blue-light">*</span>
                      </label>
                      <div className="form__input-group">
                        <select
                          className="form__input"
                          placeholder="please choose"
                          {...register('region')}
                          onBlur={(e) =>
                            e.target.classList.remove('validation-error')
                          }
                        >
                          <option value="">please choose</option>
                          <option value="Central Texas">Central Texas</option>
                          <option value="East Texas">East Texas</option>
                          <option value="Gulf Coast">Gulf Coast</option>
                          <option value="North Central Texas">
                            North Central Texas
                          </option>
                          <option value="Panhandle Plains">
                            Panhandle Plains
                          </option>
                          <option value="South Texas">South Texas</option>
                          <option value="West Texas">West Texas</option>
                        </select>
                        <i className="icon-caret-down"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid grid--std">
                  <div className="grid__col-xs-12">
                    <div className="form__field">
                      <label className="form__label">
                        Event Type{' '}
                        <span className="u--color-blue-light">*</span>
                      </label>
                      <div className="form__input-group">
                        <select
                          className="form__input"
                          placeholder="please choose"
                          {...register('type')}
                          onBlur={(e) =>
                            e.target.classList.remove('validation-error')
                          }
                        >
                          <option value="">please choose</option>
                          <option value="Festival/Fairs">Festival/Fairs</option>
                          <option value="Museums/Galleries">
                            Museums/Galleries
                          </option>
                          <option value="Music/Theatre">Music/Theatre</option>
                          <option value="Sports/Recreation">
                            Sports/Recreation
                          </option>
                          <option value="Other">Other</option>
                        </select>
                        <i className="icon-caret-down"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid grid--std">
                  <div className="grid__col-xs-12">
                    <div className="form__field">
                      <label className="form__label">Address</label>
                      <input
                        type="text"
                        className="form__input address__input"
                        {...register('addressOne')}
                      />
                      <input
                        type="text"
                        className="form__input"
                        {...register('addressTwo')}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid--std">
                  <div className="grid__col-xs-12 grid__col-lg-4">
                    <div className="form__field">
                      <label className="form__label">
                        City/Town
                        <span className="u--color-blue-light"> *</span>
                      </label>
                      <input
                        className="form__input"
                        type="text"
                        {...register('city')}
                        onBlur={(e) =>
                          e.target.classList.remove('validation-error')
                        }
                      />
                    </div>
                  </div>
                  <div className="grid__col-xs-12 grid__col-lg-4">
                    <div className="form__field">
                      <label className="form__label">State</label>
                      <input
                        className="form__input"
                        type="text"
                        defaultValue="TX"
                        readOnly
                        {...register('state')}
                      />
                      <small className="form__help">
                        We only allow events in Texas
                      </small>
                    </div>
                  </div>
                  <div className="grid__col-xs-12 grid__col-lg-4">
                    <div className="form__field">
                      <label className="form__label">Zip Code</label>
                      <input
                        className="form__input"
                        type="text"
                        {...register('zip')}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid--std">
                  <div className="grid__col-xs-12">
                    <div className="form__field">
                      <label className="form__label">Phone Number</label>
                      <input
                        className="form__input mask-input-phone"
                        type="text"
                        {...register('phone')}
                        onBlur={(e) =>
                          e.target.classList.remove('validation-error')
                        }
                        onInput={(e) => {
                          maskPhoneInput(e);
                        }}
                      />
                      <small className="form__help">include area code</small>
                    </div>
                  </div>
                </div>
                <div className="grid grid--std">
                  <div className="grid__col-xs-12">
                    <div className="form__field">
                      <label className="form__label">Website</label>
                      <input
                        className="form__input"
                        id="website"
                        type="url"
                        {...register('website')}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid--std">
                  <div className="grid__col-xs-12">
                    <div className="form__field">
                      <label className="form__label">
                        Event Image{' '}
                        {formType === 'paid' && (
                          <span className="u--color-blue-light"></span>
                        )}
                      </label>
                      <small className="form__help form__help--upload">
                        1200 px x 800 px image, maximum file size 2 MB. Other
                        image sizes will be cropped to fit the space.
                      </small>
                      <input
                        className="form__input"
                        type={formType === 'free' ? 'text' : 'file'}
                        readOnly={formType === 'free' ? true : false}
                        id="add-event-image"
                        accept="image/*"
                        placeholder="Upgrade to a Featured Event"
                        {...register('image')}
                        onBlur={(e) =>
                          e.target.classList.remove('validation-error')
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid--std">
                  <div className="grid__col-xs-12">
                    <div className="form__field">
                      <label className="form__label">
                        Event File Attachment
                      </label>
                      <small className="form__help form__help--upload">
                        PDF, DOC, DOCX, XLS or XLSX format only | Max size: 5MB
                      </small>
                      <input
                        className="form__input"
                        type={formType === 'free' ? 'text' : 'file'}
                        readOnly={formType === 'free' ? true : false}
                        id="add-event-file"
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.xml"
                        placeholder="Upgrade to a Featured Event"
                        {...register('file')}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid--std">
                  <div className="grid__col-xs-12 grid__col-lg-8">
                    <div className="form__field">
                      <label className="form__label form__label--lg">
                        Select the date range for your event
                      </label>
                      <div className="grid grid--std">
                        <div className=" grid__col-xs-8 grid__col-md-6 grid__col-lg-6">
                          <label className="form__label">
                            Starting Date
                            <span className="u--color-blue-light"> *</span>
                          </label>
                          <div className="events-finder__input-wrapper event-finder__input-wrapper--datepicker">
                            <DatePicker
                              name="startDate"
                              selected={startDate}
                              onChange={(date) => handleStartDate(date)}
                              autoComplete="off"
                            />
                            <i className="icon-calendar"></i>
                          </div>
                        </div>
                        <div className="grid__col-xs-8 grid__col-md-6 grid__col-lg-6">
                          <label className="form__label">Ending Date</label>
                          <div className="events-finder__input-wrapper event-finder__input-wrapper--datepicker">
                            <DatePicker
                              name="endDate"
                              selected={endDate}
                              onChange={(date) => handleEndDate(date)}
                              autoComplete="off"
                            />
                            <i className="icon-calendar"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <small className="form__help form__help--disclaimer">
                      If this event spans over multiple days, please include the
                      end date.
                    </small>
                  </div>
                </div>
                <p className="add-event__disclaimer u--margin-bottom-10">
                  <i>Texas Co-op Power</i> protects your confidential
                  information using the latest in secure server technology.
                </p>
                <p className="add-event__disclaimer">
                  <i>Texas Co-op Power</i> lists events across the state for the
                  benefit and enjoyment of co-op members. Events are approved at
                  our discretion.
                </p>
                {paidFormIsValid && (
                  <>
                    <SelectPlan paidPlan={paidPlan} setPaidPlan={setPaidPlan} />
                    <div className="grid grid--std">
                      <div className="grid__col-xs-6 grid__col-lg-4">
                        <div className="form__field">
                          <label className="form__label">Coupon Code</label>
                          <input
                            ref={couponInput}
                            className="form__input"
                            type="text"
                            name="event-city"
                          />
                          <span
                            className="add-event__coupon"
                            onClick={() => setCoupon(couponInput.current.value)}
                          >
                            Apply Coupon
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {!paidFormIsValid && (
                  <div className="grid grid--std">
                    <div className="grid__col-xs-2">
                      <input
                        value={formType === 'paid' ? 'Next' : 'Submit'}
                        type="submit"
                        className="btn btn--blue"
                      />
                    </div>
                  </div>
                )}
              </form>
            </div>
            <div className="grid__col-lg-4 u--hidden-xs u--hidden-sm u--hidden-md"></div>
          </div>
        </div>
      </section>
    </div>
  );
}

function FormTypeOptions({ changeFormType, formType }) {
  return (
    <div className="add-event__choices">
      <div className="grid grid--std">
        <div className="grid__col-lg-6">
          <div
            className={`add-event__choice ${
              formType === 'free' ? 'active' : ''
            }`}
          >
            <label
              className="add-event__checkbox-label"
              onClick={() => {
                changeFormType('free');
              }}
            ></label>
            <input
              checked={formType === 'free' ? true : false}
              type="checkbox"
              id="free-event-toggle"
              readOnly
            />
            <div className="add-event__checkbox">
              <div className="add-event__checkbox-inner"></div>
            </div>
            <div className="add-event__label">Free Event</div>
          </div>
        </div>
        <div className="grid__col-lg-6">
          <div
            className={`add-event__choice ${
              formType === 'paid' ? 'active' : ''
            }`}
          >
            <label
              className="add-event__checkbox-label"
              onClick={() => {
                changeFormType('paid');
              }}
            ></label>
            <input
              checked={formType === 'paid' ? true : false}
              type="checkbox"
              id="paid-event-toggle"
              readOnly
            />
            <div className="add-event__checkbox">
              <div className="add-event__checkbox-inner"></div>
            </div>
            <div className="add-event__label">Upgrade to a Featured Event</div>
          </div>
        </div>
      </div>
    </div>
  );
}
